<div class="row">
  <div class="text-center my-5" *ngIf="isGettingTanque">
    <app-spinner
      [message]="
        editMode ? 'Cargando detalles del equipo' : 'Cargando formulario'
      "
    ></app-spinner>
  </div>
  <div class="col-xs-12" *ngIf="!isGettingTanque">
    <h3>
      {{ editMode ? "Actualizar Documentos del" : "Nuevo" }} {{ entityName }}
    </h3>
    <form [formGroup]="tanqueForm" (ngSubmit)="onSubmit()">
      <div *ngIf="!editMode">
        <div class="container-fluid">
          <h4>
            Transportista
            <span *ngIf="!editMode" class="text-danger fs-4">*</span>
          </h4>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <select
                  *ngIf="isCarrier"
                  id="tanque-carrier"
                  formControlName="carrier"
                  class="form-select"
                >
                  <option [value]="carrierValueId()" selected>
                    {{ carrierValueToDisplay() }}
                  </option>
                </select>
                <select
                  *ngIf="isAdmin"
                  id="tanque-carrier-admin"
                  formControlName="carrier"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let carrier of master.CARRIERS"
                    [ngValue]="carrier.valueId"
                  >
                    {{ carrier.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="container-fluid">
          <h4>{{ entityName }}</h4>
          <div class="row">
            <div id="tanque-licensePlate" class="col-sm">
              <label
                id="tanque-licensePlate-text"
                for="licensePlate"
                class="form-label"
                >Patente
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <input
                  type="text"
                  id="tanque-licensePlate-input"
                  formControlName="licensePlate"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: {{
                    business === 'FOREIGN' ? '1234-ABC' : 'AABB00'
                  }}"
                  appInputUppercase
                />
                <div
                  id="tanque-licensePlate-helper"
                  *ngIf="showHelper(tanqueForm.get('licensePlate'))"
                >
                  <small class="form-text text-muted">
                    {{ helperMessages(tanqueForm.get("licensePlate")) }}
                  </small>
                </div>
              </div>
            </div>
            <div id="tanque-center" class="col-sm">
              <label id="tanque-center-text" for="center" class="form-label"
                >Centro
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="tanque-center-select"
                  formControlName="center"
                  class="form-select"
                  (change)="onTanqueCenterChange()"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let center of master.CENTERS"
                    [ngValue]="center.valueId"
                  >
                    {{ center.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div id="tanque-subBusiness" *ngIf="!isForeign()" class="row">
            <div class="col-sm">
              <label
                id="tanque-subBusiness-text"
                for="subBusiness"
                class="form-label"
                >Sub-negocio
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="tanque-subBusiness-select"
                  formControlName="subBusiness"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let subBusiness of master['SUB_BUSINESSES']"
                    [ngValue]="subBusiness.valueId"
                  >
                    {{ subBusiness.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row my-2">
            <div id="tanque-brand" class="col-sm">
              <label id="tanque-brand-text" for="brand" class="form-label"
                >Marca
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="tanque-brand-select"
                  formControlName="brand"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let brand of master['VEHICLES#BRANDS']"
                    [ngValue]="brand.valueId"
                  >
                    {{ brand.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
            <div id="tanque-model" class="col-sm">
              <label id="tanque-model-text" for="model" class="form-label"
                >Modelo
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <input
                  type="text"
                  id="tanque-model-input"
                  formControlName="model"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: Volvo FH"
                  appInputTrim
                />
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row my-2">
            <div id="tanque-year" class="col-sm">
              <label id="tanque-year-text" for="year" class="form-label"
                >Año de Fabricación
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <input
                  type="number"
                  id="tanque-year-input"
                  formControlName="year"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 2020"
                />
              </div>
            </div>
            <div id="tanque-color" class="col-sm">
              <label id="tanque-color-text" for="color" class="form-label"
                >Color
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="tanque-color-select"
                  formControlName="color"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let color of master['VEHICLES#COLORS']"
                    [ngValue]="color.valueId"
                  >
                    {{ color.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid border rounded p-2 my-2">
          <div class="row">
            <div class="col-sm">
              <div class="container-fluid">
                <div class="row">
                  <div id="tanque-volume" class="col-sm">
                    <label for="volume" class="form-label"
                      >Volumen
                      <span *ngIf="!editMode" class="text-danger fs-4"
                        >*</span
                      ></label
                    >
                    <div class="form-group">
                      <select
                        *ngIf="business !== 'FOREIGN'"
                        id="tanque-volume-select"
                        formControlName="volume"
                        class="form-select"
                        (change)="onTanqueVolumeChange()"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="let volume of tanquesVolumes"
                          [ngValue]="volume.valueId"
                        >
                          {{ volume.valueToDisplay }}
                        </option>
                      </select>
                      <select
                        *ngIf="business === 'FOREIGN'"
                        id="tanque-volume-select-foreing"
                        formControlName="volume"
                        class="form-select"
                        (change)="onTanqueVolumeChange()"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="let volume of foreingVolumen"
                          [ngValue]="volume"
                        >
                          {{ volume }} m3
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div id="tanque-containersNumber" class="col-sm">
                    <label for="containersNumber" class="form-label"
                      >Número de Compartimentos
                      <span *ngIf="!editMode" class="text-danger fs-4"
                        >*</span
                      ></label
                    >
                    <div class="form-group">
                      <select
                        *ngIf="business !== 'FOREIGN'"
                        id="tanque-containersNumber-select"
                        formControlName="containersNumber"
                        class="form-select"
                        (change)="onTanqueContainersNumberChange()"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="
                            let containersNumber of tanquesContainersNumbers
                          "
                          [ngValue]="containersNumber.valueId"
                        >
                          {{ containersNumber.valueToDisplay }}
                        </option>
                      </select>
                      <select
                        *ngIf="business === 'FOREIGN'"
                        id="tanque-containersNumber-select-foreing"
                        formControlName="containersNumber"
                        class="form-select"
                        (change)="onTanqueContainersNumberChange()"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="let containersNumber of foreingCompartiments"
                          [ngValue]="containersNumber"
                        >
                          {{ containersNumber }} Compartimentos
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div id="tanque-capacity" class="col-sm">
                    <label for="capacity" class="form-label"
                      >Capacidad
                      <span *ngIf="!editMode" class="text-danger fs-4"
                        >*</span
                      ></label
                    >
                    <div class="form-group" *ngIf="business !== 'FOREIGN'">
                      <select
                        id="tanque-capacity-select"
                        formControlName="capacity"
                        class="form-select"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="let capacity of tanquesCapacities"
                          [ngValue]="capacity.valueId"
                        >
                          {{ capacity.valueToDisplay }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="form-group capacity-container"
                      *ngIf="business === 'FOREIGN'"
                      formArrayName="capacity"
                    >
                      <div
                        *ngFor="let item of range; let i = index"
                        class="capacity-secction"
                      >
                        <div class="position-relative">
                          <input
                            id="tanque-capacity-input-foreing"
                            type="number"
                            class="form-control"
                            step="0.01"
                            [formControlName]="i"
                            (input)="onInputChange(i)"
                            (blur)="hideSuggestions(i)"
                            placeholder="10.00"
                          />

                          <ul
                            class="list-group position-absolute w-100"
                            *ngIf="
                              filteredSuggestions[i]?.length &&
                              showSuggestions[i]
                            "
                            style="
                              z-index: 10;
                              max-height: 200px;
                              overflow-y: auto;
                            "
                          >
                            <li
                              class="list-group-item list-group-item-action"
                              *ngFor="let suggestion of filteredSuggestions[i]"
                              (mousedown)="selectSuggestion(i, suggestion)"
                            >
                              {{ suggestion }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="tanque-capacity-image"
              class="col-sm text-center"
              *ngIf="business !== 'FOREIGN'"
            >
              <app-tanker
                [totalVolume]="volumeToDisplay"
                [compartments]="capacitiesDisplay"
              ></app-tanker>
            </div>
          </div>
        </div>

        <div class="container-fluid">
          <div class="row my-2">
            <div id="tanque-height" class="col-sm">
              <label for="height" class="form-label"
                >Alto (metros)
                <span *ngIf="!editMode && isNotForeign" class="text-danger fs-4"
                  >*</span
                ></label
              >
              <div class="form-group">
                <input
                  type="number"
                  min="1"
                  max="50"
                  step="0.1"
                  id="tanque-height-input"
                  formControlName="height"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 4.00"
                />
                <div *ngIf="showHelper(tanqueForm.get('height'))">
                  <small class="form-text text-muted">
                    {{ helperMessages(tanqueForm.get("height")) }}
                  </small>
                </div>
              </div>
            </div>
            <div id="tanque-width" class="col-sm">
              <label for="width" class="form-label"
                >Ancho (metros)
                <span *ngIf="!editMode && isNotForeign" class="text-danger fs-4"
                  >*</span
                ></label
              >
              <div class="form-group">
                <input
                  type="number"
                  min="1"
                  max="50"
                  step="0.1"
                  id="tanque-width-input"
                  formControlName="width"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 2.55"
                />
                <div *ngIf="showHelper(tanqueForm.get('width'))">
                  <small class="form-text text-muted">
                    {{ helperMessages(tanqueForm.get("width")) }}
                  </small>
                </div>
              </div>
            </div>
            <div id="tanque-length" class="col-sm">
              <label for="length" class="form-label"
                >Largo (metros)
                <span *ngIf="!editMode && isNotForeign" class="text-danger fs-4"
                  >*</span
                ></label
              >
              <div class="form-group">
                <input
                  type="number"
                  min="1"
                  max="50"
                  step="0.1"
                  id="tanque-length-input"
                  formControlName="length"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 13.95"
                />
                <div *ngIf="showHelper(tanqueForm.get('length'))">
                  <small class="form-text text-muted">
                    {{ helperMessages(tanqueForm.get("length")) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid">
          <div class="row my-2">
            <div id="tanque-bulkhead" class="col-sm">
              <label for="bulkheadType" class="form-label"
                >Tipo de Mamparo
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="tanque-bulkheadType-input"
                  formControlName="bulkheadType"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let bulkhead of master['TANQUES#BULKHEAD_TYPES']"
                    [ngValue]="bulkhead.valueId"
                  >
                    {{ bulkhead.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="business === 'FUELS'" class="container-fluid">
          <div class="row my-2">
            <div id="tanque-usos" class="col-sm">
              <label class="form-label"
                >Usos
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <app-multi-select
                  placeholder="Seleccione Usos."
                  [formControl]="usesControl"
                  [options]="multiOpts"
                ></app-multi-select>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row my-2 align-items-center">
            <div
              id="tanque-forMining"
              class="col-sm text-center border rounded mx-1"
            >
              <p class="pt-1">
                Usado en minería
                <span *ngIf="!editMode" class="text-danger fs-4">*</span>
              </p>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="tanque-forMiningYes"
                  formControlName="forMining"
                  class="form-check-input"
                  value="true"
                />
                <label for="forMiningYes" class="form-check-label">Sí</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="tanque-forMiningNo"
                  formControlName="forMining"
                  class="form-check-input"
                  value="false"
                />
                <label for="forMiningNo" class="form-check-label">No</label>
              </div>
            </div>
            <div
              id="tanque-hasRanchAccreditation"
              class="col-sm text-center border rounded mx-1"
            >
              <p class="pt-1">
                Tiene Acreditación Ranchera
                <span *ngIf="!editMode" class="text-danger fs-4">*</span>
              </p>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="tanque-hasRanchAccreditationYes"
                  formControlName="hasRanchAccreditation"
                  class="form-check-input"
                  value="true"
                />
                <label for="hasRanchAccreditationYes" class="form-check-label"
                  >Sí</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="tanque-hasRanchAccreditationNo"
                  formControlName="hasRanchAccreditation"
                  class="form-check-input"
                  value="false"
                />
                <label for="hasRanchAccreditationNo" class="form-check-label"
                  >No</label
                >
              </div>
            </div>
            <div
              id="tanque-Pump"
              class="col-sm text-center border rounded mx-1"
            >
              <p class="pt-1">
                Tiene Bomba
                <span *ngIf="!editMode" class="text-danger fs-4">*</span>
              </p>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="tanque-hasPumpYes"
                  formControlName="hasPump"
                  class="form-check-input"
                  value="true"
                />
                <label for="hasPumpYes" class="form-check-label">Sí</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="tanque-hasPumpNo"
                  formControlName="hasPump"
                  class="form-check-input"
                  value="false"
                />
                <label for="hasPumpNo" class="form-check-label">No</label>
              </div>
            </div>
            <div
              id="tanque-isSpot"
              class="col-sm text-center border rounded mx-1"
            >
              <p class="pt-1">
                Es Spot
                <span *ngIf="!editMode" class="text-danger fs-4">*</span>
              </p>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="tanque-isSpotYes"
                  formControlName="isSpot"
                  class="form-check-input"
                  value="true"
                />
                <label for="isSpotYes" class="form-check-label">Sí</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="tanque-isSpotNo"
                  formControlName="isSpot"
                  class="form-check-input"
                  value="false"
                />
                <label for="isSpotNo" class="form-check-label">No</label>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row my-2">
            <div id="tanque-gpsImei" class="col-sm">
              <label for="gpsImei" class="form-label">GPS IMEI</label>
              <div class="form-group">
                <input
                  type="text"
                  id="tanque-gpsImei-input"
                  formControlName="gpsImei"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 123456789012345"
                  appInputTrim
                />
              </div>
            </div>
            <div id="tanque-cameraImei" class="col-sm">
              <label for="cameraImei" class="form-label">Cámara IMEI</label>
              <div class="form-group">
                <input
                  type="text"
                  id="tanque-cameraImei-input"
                  formControlName="cameraImei"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 123456789012345"
                  appInputTrim
                />
              </div>
            </div>
            <div id="tanque-MOPCode" class="col-sm">
              <label for="MOPCode" class="form-label">Código MOP</label>
              <div class="form-group">
                <input
                  type="text"
                  id="tanque-MOPCode-input"
                  formControlName="MOPCode"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 123456789012345"
                  appInputTrim
                />
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="business === 'FUELS'">
          <div class="container-fluid">
            <div class="row my-2">
              <div id="tanque-SECCertificate" class="col-sm">
                <label
                  id="tanque-SECCertificate-text"
                  for="SECCertificate"
                  class="form-label"
                  >N° certificado SEC
                  <span *ngIf="!editMode" class="text-danger fs-4"
                    >*</span
                  ></label
                >
                <div class="form-group">
                  <input
                    type="number"
                    id="tanque-SECCertificate-input"
                    formControlName="SECCertificate"
                    class="form-control immutable-field"
                    placeholder="Ejemplo: 345678901234567"
                    appInputTrim
                  />
                </div>
              </div>
              <div id="tanque-SECDate" class="col-sm">
                <label id="tanque-SECDate-text" for="SECDate" class="form-label"
                  >Fecha de inscripción SEC
                  <span *ngIf="!editMode" class="text-danger fs-4"
                    >*</span
                  ></label
                >
                <div class="form-group">
                  <input
                    type="date"
                    id="tanque-SECDate"
                    max="{{ maxDate }}"
                    formControlName="SECDate"
                    class="form-control"
                  />
                  <ng-container
                    *ngIf="
                      tanqueForm.controls['SECDate'].hasError('futureDate') &&
                      tanqueForm.controls['SECDate'].touched
                    "
                  >
                    <span
                      >{{ tanqueForm.controls['SECDate'].errors?.['futureDate'] }}</span
                    >
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid">
            <div class="row my-2">
              <div id="tanque-SECFolio" class="col-sm">
                <label
                  id="tanque-SECFolio-text"
                  for="SECFolio"
                  class="form-label"
                  >N° Folio inscripción SEC
                  <span *ngIf="!editMode" class="text-danger fs-4"
                    >*</span
                  ></label
                >
                <div class="form-group">
                  <input
                    type="number"
                    id="tanque-SECFolio-input"
                    formControlName="SECFolio"
                    class="form-control immutable-field"
                    placeholder="Ejemplo: 234567890123456"
                    appInputTrim
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <hr />
      </div>
      <div class="container-fluid">
        <h5 class="dc-header-title">
          <span>
            <i class="material-symbols-outlined align-middle">description</i>
            Documentos {{ editMode ? "de " + tanqueIdentification : "" }}
          </span>
          <div class="dc-switch-container">
            <label class="dc-switch-text">Mostrar solo obligatorios</label>
            <label class="dc-switch">
              <input type="checkbox" formControlName="onlyMandatory" />
              <span class="dc-slider round"></span>
            </label>
          </div>
        </h5>
        <div class="alert alert-warning" role="alert" *ngIf="!archiveMode">
          <i class="material-symbols-outlined align-middle">warning</i> Solo se
          aceptan documentos en formato PDF.
        </div>
        <div class="alert alert-info" role="alert" *ngIf="archiveMode">
          <i class="material-symbols-outlined align-middle">info</i> Se copiarán
          los documentos del {{ entityName }} anterior.
        </div>
        <div class="col-xs-12" formArrayName="documents" *ngIf="!archiveMode">
          <ng-container
            *ngFor="let documentControl of documentsControl; let i = index"
          >
            <div
              class="row border-top"
              id="tanque-documents"
              *ngIf="
                isMandatoryDocument(
                  documentControl.get('documentMasterValueId')?.value
                ) || !mandatorySlider
              "
              [formGroupName]="i"
            >
              <div class="row my-2">
                <div class="col-sm-11">
                  <input
                    type="text"
                    id="tanque-documentName"
                    class="form-control-plaintext form-control-lg"
                    formControlName="documentName"
                    readonly
                  />
                </div>
                <div
                  class="col-sm-1"
                  *ngIf="
                    !editMode &&
                    isMandatoryDocument(
                      documentControl.get('documentMasterValueId')?.value
                    )
                  "
                >
                  <p class="text-danger fs-4">*</p>
                </div>
              </div>
              <div
                *ngIf="
                  editMode &&
                  invalidControl(documentControl.get('documentExpirationDate'))
                "
              >
                <small id="tanque-document-alert" class="form-text text-danger">
                  Documento vencido, es necesario actualizar.
                </small>
              </div>
              <div
                class="row"
                *ngIf="
                  !isDatelessDocument(
                    documentControl.get('documentMasterValueId')?.value
                  )
                "
              >
                <label for="documentIssueDate" class="col-sm-2 col-form-label"
                  >Emisión</label
                >
                <div class="col-sm-4">
                  <input
                    type="date"
                    id="tanque-documentIssueDate"
                    formControlName="documentIssueDate"
                    class="form-control"
                  />
                  <div
                    *ngIf="showHelper(documentControl.get('documentIssueDate'))"
                  >
                    <small class="form-text text-muted">
                      {{
                        helperMessages(documentControl.get("documentIssueDate"))
                      }}
                    </small>
                  </div>
                </div>
                <label
                  for="documentExpirationDate"
                  class="col-sm-2 col-form-label"
                  >Vencimiento</label
                >
                <div class="col-sm-4">
                  <input
                    type="date"
                    id="tanque-documentExpirationDate"
                    formControlName="documentExpirationDate"
                    class="form-control"
                  />
                  <div
                    *ngIf="
                      showHelper(documentControl.get('documentExpirationDate'))
                    "
                  >
                    <small
                      id="tanque-document-helper"
                      class="form-text text-muted"
                    >
                      {{
                        helperMessages(
                          documentControl.get("documentExpirationDate")
                        )
                      }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row my-2">
                <div class="col-sm-12">
                  <input
                    type="file"
                    accept=".pdf"
                    id="tanque-documentFile"
                    formControlName="documentFile"
                    class="form-control"
                    (change)="onChangeDocumentFile($event, i)"
                  />
                  <div *ngIf="showHelper(documentControl.get('documentFile'))">
                    <small class="form-text text-muted">
                      {{ helperMessages(documentControl.get("documentFile")) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-xs-12">
          <button
            id="tanque-edit-cancel"
            type="button"
            class="btn btn-outline-danger"
            (click)="onCancel()"
          >
            Cancelar
          </button>
          <button
            id="tanque-edit-show"
            type="button"
            class="btn btn-outline-secondary mx-2"
            (click)="showForm()"
            *ngIf="isDev"
          >
            Log Form
          </button>
          <button
            id="tanque-edit-submit"
            type="submit"
            class="btn btn-outline-primary mx-2 float-end"
            [disabled]="disableSubmit"
          >
            {{ editMode ? "Actualizar Documentos" : "Crear " + entityName }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
